module.exports = __webpack_public_path__ + "img/icon-plketang-logo.8f264431.png";